@if (queryKey() === undefined) {
<p class="dashboard-provenance__message">{{ 'Dashboard.Provenance.NoQuery' | translate }}</p>
} @else if (provenanceText(); as text) {
<p class="dashboard-provenance__line">{{ text }}</p>
}
